import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseState } from '../../reducers';
import { FloatLabelModule } from 'primeng/floatlabel';
import { createPersonalPreset } from '../store/editor.actions';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-create-preset-dialog',
  standalone: true,
  imports: [
    ButtonModule,
    FloatLabelModule,
    ButtonModule,
    FormsModule,
    InputTextModule
  ],
  templateUrl: './create-preset-dialog.component.html',
  styleUrl: './create-preset-dialog.component.scss'
})
export class CreatePresetDialogComponent {
  presetName: string

  constructor(private dialog: DynamicDialogRef, private store: Store<BaseState>){}

  closeDialog(){
    this.dialog.close()
  }

  createPreset(){
    if(!this.presetName) return
    this.store.dispatch(createPersonalPreset({name: this.presetName}))
    setTimeout(() => this.closeDialog(), 300)
  }

}
